import React, { useReducer, useContext } from "react";
import "./LocationTypeToggle.scss";
import { ApplyFilterSection } from "./ApplyFilterSection";
import {
  MultiSelectOptionSet,
  optionReducer,
} from "./CustomSelect/CustomSelectUtil";
import { isValidArray } from "../../store/util";
import { RootStoreContext } from "../../store/rootStore";
import ReactGA from 'react-ga';

export const SurveyAreaTypeToggle: React.FC<{
  surveyAreaTypes: MultiSelectOptionSet[];
}> = ({ surveyAreaTypes }) => {
  const [options, dispatchOption] = useReducer(optionReducer, surveyAreaTypes);
  const rootStore = useContext(RootStoreContext);

  const { applySurveyAreaTypeFilter } = rootStore.filterStore;

  function onItemSelected(option: MultiSelectOptionSet) {
    dispatchOption({ type: "toggle", option: option });
  }

  function onApplyFilterClick() {
    const selected = options
      .filter((item) => item.isSelected)
      .map((item) => ({ value: parseInt(item.value, 10), label: item.label }));

    if (isValidArray(selected)) {
      applySurveyAreaTypeFilter(selected);
    } else {
      applySurveyAreaTypeFilter(null);
    }
    ReactGA.event({
      category: 'Survey Type Filter',
      action: 'Apply Filter'
    })
  }

  return (
    <div className="survey_toggle_container">
      {options.map((element: MultiSelectOptionSet) => (
        <div
          key={`${element.value}_${element.set}`}
          className="checkbox_container"
        >
          <input
            type="checkbox"
            id={`env_${element.value}_${element.set}`}
            checked={element.isSelected}
            onChange={(event) => onItemSelected(element)}
          />
          <label htmlFor={`env_${element.value}_${element.set}`}>
            {element.label}
          </label>
        </div>
      ))}
      <ApplyFilterSection onClick={onApplyFilterClick} />
    </div>
  );
};
